export default __webpack_public_path__ + "static/media/Highlights_title_rollover.13b190be.svg";